// extracted by mini-css-extract-plugin
export default {"container":"Home__container--j7Cns"};